export interface PlantsRequest {
  countryCode: string;
  regionCode?: string;
  productId?: string;
  productTypeId?: string;
  shipmentLocationId?: string;
  shippingConditionCode?: string;
  jobsiteId?: string;
}
